import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import {configData} from "../../config";

export default function CurrencyConverter({ price }) {

    const [selectedCountry, setSelectedCountry] = useState("GB");
    const [countrieslist, setCountriesList] = useState({});
    const [convertedText, setConvertedText] = useState("");
    const [priceContainer, setPriceContainer] = useState(null);
    const converterRef = useRef(null);
    const app_url = configData.APP_URL;
    // On the Drupal site the converted price is its own block under the table that holds
    // the country list and the globe. The converter is mounted inside that table, so make
    // a place for the price right after the block the table is in.
    useEffect(() => {
        const tableBlock = converterRef.current.closest('.payment_description');
        if (!tableBlock) return;

        const container = document.createElement('div');
        tableBlock.after(container);
        setPriceContainer(container);
        return () => container.remove();
    }, []);
    useEffect(() => {
            Promise.all([
              retrieveCountriesList(),
             getCurrencyCalculation(selectedCountry),
            ])
            .then(() => {
         
            
            })
         
        },[]);
async function retrieveCountriesList() {
    const countrieslistresponse = await fetch(
      app_url+'smwwcountries/getcountrieslist',
      {
        method: "GET",

        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const countrieslistdata = await countrieslistresponse.json();

    setCountriesList(countrieslistdata.data.result);
   
    
    
  }
  const getCurrencyCalculation = async (country) => {
    // When no price comes back the line is emptied, so the price of the
    // previously selected country is never left on screen
    let text = "";
    try {
      const postData = {
           country: country,
           price:price
          };
      const response = await fetch(app_url + 'coursepages/getcountryprice', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
        'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if(data.data && data.data.msg === "Success") {
        text = data.data.text;
      }
    } catch (err) {
      console.error(err);
    }
    setConvertedText(text);
};
  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value);
    getCurrencyCalculation(e.target.value);
};
    const convertedPrice = (
        <div
            className="payment_description converted_price"
            dangerouslySetInnerHTML={{ __html: convertedText }}
        ></div>
    );
    return (
        <div className="currency-converter" ref={converterRef}>
            <span className="pay_heading">PRICE IN </span>

            <select id= "currency_select_0"
                value={selectedCountry}
                onChange={handleCountryChange}
            >
                <optgroup label="Top Countries">
                <option value="US">United States</option>
                <option value="GB">United Kingdom</option>
                <option value="IN">India</option>
                <option value="AU">Australia</option>
                <option value="CA">Canada</option></optgroup>
                <optgroup label="All Countries">
                 {Array.isArray(countrieslist) &&countrieslist.map((country) => (
        <option key={country.value} value={country.value}>
            {country.label}
        </option>
    ))}</optgroup>
            </select>
            {priceContainer ? createPortal(convertedPrice, priceContainer) : convertedPrice}
        </div>
    );
}